import React from "react";
import { InfoIcon } from "lucide-react";
import { Section } from "../Section";
import { CTAButton } from "../CTAButton";
export function Commitment() {
  return <Section className="bg-cream" data-id="element-128" data-mp="3hm4p3jdskfcc">
      <div className="grid gap-10 md:grid-cols-2 md:gap-14" data-id="element-129" data-mp="3csa84npkmegy">
        <div data-id="element-130" data-mp="3cqped0b2yzk5">
          <h2 className="text-balance font-display text-[30px] font-bold leading-[1.1] text-navy sm:text-4xl" data-id="element-131" data-mp="37u8oo1o8gd4y">
            A practical resource collection you can return to
          </h2>
          <div className="mt-5 space-y-4 text-lg leading-relaxed text-ink/85" data-id="element-132" data-mp="2ytaipdu8hvjq">
            <p data-id="element-133" data-mp="2yvdj8rt0j72p">
              Speech sound planning requires attention to individual communication needs, relevant observations, and
              professional judgment.
            </p>
            <p data-id="element-134" data-mp="2owo2518xxqni">No single worksheet or collection of activities can account for every child or replace an individualized assessment.</p>
            <p data-id="element-135" data-mp="n3qbnc2mza5q">
              My aim with this collection is to help you organize the educational materials and documentation involved
              in your workflow.
            </p>
            <p data-id="element-136" data-mp="2edaemlok67ra">
              You can use the worksheets as starting points, adapt the resources to the child and context, and make
              professional decisions based on your assessment, training, and applicable standards.
            </p>
            <p className="font-bold text-navy" data-id="element-137" data-mp="29bbf5mvxvuzm">
              The collection is designed to support organization, not to prescribe a universal treatment approach.
            </p>
          </div>
        </div>

        <aside className="self-start rounded-3xl border-2 border-dashed border-sky/40 bg-white p-6 sm:p-8" data-id="element-138" data-mp="31zqr20jrxx6q">
          <div className="flex items-center gap-2" data-id="element-139" data-mp="2nb2ze5d1u7m2">
            <InfoIcon className="h-5 w-5 text-sky" aria-hidden="true" data-id="element-140" data-mp="2sayzhtimlewc" />
            <h3 className="font-display text-xl font-bold text-navy" data-id="element-141" data-mp="2s8w3msuskrjp">About this educational resource</h3>
          </div>
          <div className="mt-4 space-y-3 text-[16px] leading-relaxed text-ink/80" data-id="element-142" data-mp="3kr9qjxelat40">
            <p data-id="element-143" data-mp="3ktcor4pwbsjt">
              The Pediatric Articulation Clinical Blueprint™ is an educational resource designed to support
              professional organization and planning.
            </p>
            <p data-id="element-144" data-mp="3pm2q0in7363j">
              It is not a diagnostic instrument, a standardized assessment, or a validated clinical treatment protocol.
              It does not replace individualized assessment, professional judgment, specialist training, or applicable
              professional standards.
            </p>
            <p data-id="element-145" data-mp="3bq7ewyz1ezap">
              All resources should be reviewed and adapted to the needs, preferences, communication goals, and
              circumstances of each child.
            </p>
          </div>
        </aside>
      </div>

      <div className="mt-12 text-center" data-id="element-146" data-mp="2x00495f9ukkk">
        <p className="font-display text-2xl font-bold text-navy" data-id="element-147" data-mp="2x12vjegiap10">Start organizing your articulation planning today</p>
        <p className="mt-1 text-lg text-ink/80" data-id="element-148" data-mp="2szzdclazkgwm">Get all six volumes and five specialized bonuses for $27.</p>
        <div className="mt-6" data-id="element-149" data-mp="2o161exbckxyk">
          <CTAButton label="Yes! I want the Blueprint" data-id="element-150" data-mp="13haq1lr0g126" />
        </div>
      </div>
    </Section>;
}